import { ColorType } from "@/types/colors";

export enum ColorTypeField {
  FILTERS = "filters",
  PROPERTIES = "properties",
}

export const colors = {
  [ColorType.WHITE]: {
    filters: "#FFFFFF",
    properties: "#FFFFFF",
  },
  [ColorType.BLACK]: {
    filters: "#666666",
    properties: "#252424",
  },
  [ColorType.BLUE]: {
    filters: "#5C93FE",
    properties: "#0B3483",
  },
  [ColorType.GREEN]: {
    filters: "#B5DE9C",
    properties: "#1F551B",
  },
  [ColorType.YELLOW]: {
    filters: "#FAFEE5",
    properties: "#F9C40A",
  },
  [ColorType.RED]: {
    filters: "#FE7B7B",
    properties: "#C50C00",
  },
  [ColorType.SILVER]: {
    filters: "#E5E5E5",
    properties: "#8F939C",
  },
  [ColorType.ORANGE]: {
    filters: "#FFE4CA",
    properties: "#FB7D08",
  },
  [ColorType.BROWN]: {
    filters: "#DCAA7D",
    properties: "#5B2A07",
  },
  [ColorType.BEIGE]: {
    filters: "#FFFAF9",
    properties: "#CAB398",
  },
  [ColorType.GRAY]: {
    filters: "#AEAEAE",
    properties: "#757575",
  },
};

export function getBackgroundValue(field: ColorTypeField, color?: ColorType | undefined) {
  if (color) {
    if (field === ColorTypeField.FILTERS) {
      return `radial-gradient(64.29% 64.29% at 50% 14.29%, ${colors[color][ColorTypeField.FILTERS]} 0%, ${
        colors[color][ColorTypeField.PROPERTIES]
      } 100%)`;
    }
    return color === ColorType.SILVER
      ? colors[color][ColorTypeField.FILTERS]
      : colors[color][ColorTypeField.PROPERTIES];
  }
  return;
}

export function getColorType(color: string): ColorType | undefined {
  const lowerCaseColor = color.toLowerCase();

  if (Object.values(ColorType).includes(lowerCaseColor as ColorType)) {
    return lowerCaseColor as ColorType;
  }

  return undefined;
}
